export enum Product {
  CLASSPAD_LEARNING = "CLASSPAD_LEARNING",
  CLASSPAD_NET_PLUS = "CLASSPAD_NET_PLUS",
  MES_EXERCISES_LYCEE = "MES_EXERCISES_LYCEE",
  CLASSWIZZ_CALC_APP = "CLASSWIZZ_CALC_APP",
}
